import { icon, type IconName } from './icons.js';

export interface EmptyStateOpts {
  icon: IconName;
  title: string;
  body?: string;
  action?: { label: string; onClick: () => void };
  /** Preserve existing data-role hooks (e.g. 'setlists-empty', 'team-empty'). */
  dataRole?: string;
}

/** Centered empty/error block: icon + title + optional body + optional action. */
export function buildEmptyState(opts: EmptyStateOpts): HTMLElement {
  const wrap = document.createElement('div');
  wrap.className = 'es-block';
  if (opts.dataRole) wrap.dataset.role = opts.dataRole;

  const ic = document.createElement('div');
  ic.className = 'es-icon';
  ic.innerHTML = icon(opts.icon); // constant SVG markup
  wrap.appendChild(ic);

  const h = document.createElement('p');
  h.className = 'es-title';
  h.textContent = opts.title;
  wrap.appendChild(h);

  if (opts.body) {
    const b = document.createElement('p');
    b.className = 'es-body';
    b.textContent = opts.body;
    wrap.appendChild(b);
  }

  if (opts.action) {
    const btn = document.createElement('button');
    btn.className = 'es-action';
    btn.innerHTML = `${icon('arrowLeft')}<span></span>`;
    (btn.querySelector('span') as HTMLElement).textContent = opts.action.label;
    btn.addEventListener('click', opts.action.onClick);
    wrap.appendChild(btn);
  }

  return wrap;
}
